import { Box, TextField } from "@mui/material";

import type { ReactElement } from "react";

// Matches the backend's hex validation (leading `#` optional, 6 hex digits).
const HEX_PATTERN = /^#?[0-9A-Fa-f]{6}$/;

const withHash = (hex: string): string =>
  hex.startsWith("#") ? hex : `#${hex}`;

interface ColorFieldProps {
  label: string;
  value: string | undefined;
  defaultHex: string;
  onChange: (next: string) => void;
}

export const ColorField = ({
  label,
  value,
  defaultHex,
  onChange,
}: ColorFieldProps): ReactElement => {
  const isEmpty = !value;
  const isValid = isEmpty || HEX_PATTERN.test(value);
  const swatchHex = withHash(!isEmpty && isValid ? value : defaultHex);

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1.5}
      width={320}
      data-testid="color-field"
    >
      <Box
        component="input"
        type="color"
        aria-label={`${label} swatch`}
        value={swatchHex}
        onChange={(e) => onChange(e.target.value)}
        sx={{
          width: 36,
          height: 36,
          p: 0,
          border: "none",
          borderRadius: 1,
          cursor: "pointer",
          opacity: isEmpty ? 0.4 : 1,
        }}
      />
      <TextField
        label={label}
        size="small"
        fullWidth
        value={value ?? ""}
        placeholder={defaultHex}
        error={!isValid}
        helperText={isValid ? undefined : "Enter a 6-digit hex color"}
        onChange={(e) => onChange(e.target.value)}
      />
    </Box>
  );
};
